import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class EndpointDashboardColoredIcon extends BaseIcon {
  getChildren = () => {
    const color = this.getColor() === 'currentColor' ? '#ff9e0e' : this.getColor()
    return [
      <g>
        <path fill={color}
          d="M34.24,16.25c-1-1-2.44-.44-3.42-1.42s-.44-2.44-1.42-3.41S27,11,26,10s-.26-2.49-1.31-3.53S22.2,6.2,21.15,5.16,20.8,2.7,19.79,1.69A2.86,2.86,0,0,0,18,1H4A3,3,0,0,0,1,4V32a3,3,0,0,0,3,3H32a3,3,0,0,0,3-3V18.24A3.5,3.5,0,0,0,34.24,16.25Z" />
        <circle fill={color} cx="28.1" cy="7.9" r="1.5" />
        <path fill={'#fff'}
          d="M24.1,17h-12a2,2,0,0,0-2,2v7a1.63,1.63,0,0,0,.07.5A2,2,0,0,1,12.09,25V19h12v7h-12a1,1,0,1,0,0,2h12a2,2,0,0,0,2-2V19A2,2,0,0,0,24.1,17Z" />
        <path fill={'#fff'}
          d="M23,16a1,1,0,0,1-1-1V13c0-1.8-1.79-3.27-4-3.27H18c-2.18,0-4,1.45-4,3.24V15a1,1,0,0,1-2,0V12.93C12,10.05,14.67,7.7,18,7.7H18c3.3,0,6,2.36,6,5.26v2A1,1,0,0,1,23,16Z" />
        <circle fill={color} cx="33" cy="7.9" r="1" />
        <circle fill={color} cx="33" cy="12.7" r="1.5" />
        <circle fill={color} cx="32.9" cy="3.1" r="0.5" />
        <circle fill={color} cx="28.1" cy="3.1" r="1" />
        <circle fill={color} cx="23.3" cy="3.1" r="1.5" />
      </g>
    ]
  }
  getViewBox = () => '0 0 36 36'
}
